<template>
  <span class="crown-filled-icon" :style="iconStyle" aria-hidden="true">
    <!-- 与 Ant Design CrownFilled 一致（项目未装 @ant-design/icons-vue，用内联 SVG） -->
    <svg viewBox="0 0 1024 1024" focusable="false" width="1em" height="1em" fill="currentColor">
      <path
        d="M899.6 276.5L705 396.4 518.4 147.5a8.06 8.06 0 0 0-12.9 0L319 396.4 124.3 276.5c-5.7-3.5-13.1 1.2-12.2 7.9L188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.8-6.7-6.5-11.4-12.3-7.9zM512 734.2c-62.1 0-112.6-50.5-112.6-112.6S449.9 509 512 509s112.6 50.5 112.6 112.6S574.1 734.2 512 734.2zm0-160.9c-26.6 0-48.2 21.6-48.2 48.3 0 26.6 21.6 48.3 48.2 48.3s48.2-21.6 48.2-48.3c0-26.6-21.6-48.3-48.2-48.3z"
      />
    </svg>
  </span>
</template>

<script>
export default {
  name: 'CrownFilledIcon',
  props: {
    size: { type: [Number, String], default: 22 },
  },
  computed: {
    iconStyle() {
      const px = typeof this.size === 'number' ? `${this.size}px` : this.size
      return { fontSize: px }
    },
  },
}
</script>

<style scoped>
.crown-filled-icon {
  display: inline-flex;
  align-items: center;
  line-height: 0;
}
</style>
